"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cityStateZip = void 0;
const cityStateZip = ({ city = '', state = '', zip = '', zipcode = zip } = {}) => {
    if (typeof city !== 'string' && typeof state !== 'string' && typeof zipcode !== 'string')
        return '';
    return `${city}${city && (state || zipcode) ? ',' : ''}${state && ' '}${state}${zipcode && ' '}${zipcode}`.trim();
};
exports.cityStateZip = cityStateZip;
//# sourceMappingURL=city-state-zip.js.map